import {Box,Container,Typography} from "@mui/material";
import {useAppTheme} from "../../context/ThemeContext";

import devzone from "../../static/Home/devzone.webp";
import novaxfit from "../../static/Home/novaxfit.webp";
import prindela from "../../static/Home/prindela.webp";
import groupservices from "../../static/Home/groupservices.webp";

const SPONSORS=[
  {
    name:"DevZone",
    image:devzone
  },
  {
    name:"Novaxfit",
    image:novaxfit
  },
  {
    name:"Prindela",
    image:prindela
  },
  {
    name:"Group Services",
    image:groupservices
  }
];

export default function SponsorsSection(){
  const {colors}=useAppTheme();

  return(
    <Box
      component="section"
      aria-label="Auspiciantes"
      sx={{
        width:"100%",
        backgroundColor:"#FFFFFF",
        py:{
          xs:6,
          sm:7,
          md:9
        }
      }}
    >
      <Container
        maxWidth="xl"
        sx={{
          px:{
            xs:2.5,
            sm:4,
            md:5,
            lg:7
          }
        }}
      >
        <Box
          sx={{
            maxWidth:760,
            mx:"auto",
            textAlign:"center"
          }}
        >
          <Typography
            component="h2"
            sx={{
              fontSize:{
                xs:27,
                sm:34,
                md:40
              },
              fontWeight:600,
              lineHeight:1.2,
              letterSpacing:"-0.035em",
              color:colors.primary,
              textAlign:"center"
            }}
          >
            Nuestros auspiciantes
          </Typography>

          <Typography
            sx={{
              mt:1.5,
              fontSize:{
                xs:14,
                sm:15,
                md:16
              },
              fontWeight:400,
              lineHeight:1.75,
              color:"#64748B",
              textAlign:"center"
            }}
          >
            Marcas que comparten nuestra pasión por el deporte
            y apoyan el crecimiento del fútbol.
          </Typography>
        </Box>

        <Box
          sx={{
            width:"100%",
            maxWidth:1100,
            mx:"auto",
            mt:{
              xs:4,
              sm:5,
              md:6
            },
            display:"grid",
            gridTemplateColumns:{
              xs:"repeat(2,minmax(0,1fr))",
              md:"repeat(4,minmax(0,1fr))"
            },
            alignItems:"center",
            justifyItems:"center",
            columnGap:{
              xs:2,
              sm:3,
              md:5
            },
            rowGap:{
              xs:3,
              sm:4
            }
          }}
        >
          {SPONSORS.map(sponsor=>(
            <Box
              key={sponsor.name}
              sx={{
                width:"100%",
                minWidth:0,
                minHeight:{
                  xs:100,
                  sm:120,
                  md:135
                },
                display:"flex",
                alignItems:"center",
                justifyContent:"center",
                px:{
                  xs:1,
                  sm:2,
                  md:2.5
                }
              }}
            >
              <Box
                component="img"
                src={sponsor.image}
                alt={`Logo de ${sponsor.name}`}
                loading="lazy"
                sx={{
                  display:"block",
                  width:"100%",
                  maxWidth:{
                    xs:145,
                    sm:175,
                    md:205
                  },
                  height:{
                    xs:90,
                    sm:105,
                    md:120
                  },
                  objectFit:"contain",
                  transition:"transform .25s ease",
                  "&:hover":{
                    transform:"scale(1.05)"
                  }
                }}
              />
            </Box>
          ))}
        </Box>

        <Box
          sx={{
            width:"100%",
            maxWidth:1100,
            height:"1px",
            mx:"auto",
            mt:{
              xs:4,
              sm:5,
              md:6
            },
            backgroundColor:"#E5EAF2"
          }}
        />
      </Container>
    </Box>
  );
}